import React from 'react';
import { tx } from '@/translations/translations';

export const RelatedProducts = ({ relatedProducts, language, onSelectProduct }) => {
  if (relatedProducts.length === 0) return null;
  return (
    <div
      className="border-t border-slate-100 px-3 sm:px-6 md:px-8 pt-4 sm:pt-6 pb-5 sm:pb-7 bg-slate-50/40"
      data-testid="related-products-section"
    >
      <h3 className="text-sm sm:text-base font-bold text-slate-800 mb-3 sm:mb-4 tracking-tight">
        {tx(language, 'También te puede interesar', 'You might also like', 'אולי יעניין אותך גם')}
      </h3>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2.5 sm:gap-4">
        {relatedProducts.map((rp) => {
          const oos = !rp.inStock;
          return (
            <button
              key={`related-${rp.id}`}
              type="button"
              onClick={() => onSelectProduct && onSelectProduct(rp)}
              className="group text-left bg-white rounded-xl overflow-hidden border border-slate-200 hover:border-cyan-400 hover:shadow-md transition-all"
              data-testid={`related-product-${rp.id}`}
            >
              <div className="relative aspect-[4/5] w-full overflow-hidden bg-white">
                <img
                  src={rp.image}
                  alt={rp.name}
                  loading="lazy"
                  className={`absolute inset-0 w-full h-full object-contain p-1 transition-transform duration-300 group-hover:scale-105 ${oos ? 'opacity-60' : ''}`}
                />
                {oos && (
                  <span className="absolute top-1.5 right-1.5 bg-red-500 text-white text-[9px] font-bold px-1.5 py-0.5 rounded-full">
                    {tx(language, 'Agotado', 'Sold out', 'אזל מהמלאי')}
                  </span>
                )}
              </div>
              <div className="p-2 sm:p-2.5">
                <p className="text-[11px] sm:text-xs font-semibold text-slate-800 leading-tight line-clamp-2 min-h-[2.4em]">
                  {rp.name}
                </p>
                <p className="mt-1 text-xs sm:text-sm font-black text-slate-900">
                  ${Number(rp.price).toFixed(0)}
                  <span className="ml-1 text-[9px] sm:text-[10px] font-bold text-cyan-600/70 align-top">{rp.currency}</span>
                </p>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};
